import PageHero from "@/components/PageHero"
import { useScrollReveal } from "@/hooks/useScrollReveal"
import {Award, Shield, FileCheck, Download, CheckCircle} from 'lucide-react'

const certificados = [
  { level: "A1", name: "Iniciante", hours: "60h", color: "#6CC4C4" },
  { level: "A2", name: "Básico", hours: "80h", color: "#0E8EA0" },
  { level: "B1", name: "Intermediário", hours: "100h", color: "#F5C542" },
  { level: "B2", name: "Intermediário Avançado", hours: "120h", color: "#B038B2" },
  { level: "C1", name: "Avançado", hours: "140h", color: "#0E8EA0" },
]

const beneficios = [
  { icon: Award, title: "Reconhecimento", text: "Certificados com carga horária reconhecida para enriquecer seu currículo." },
  { icon: Shield, title: "Validação", text: "Baseados no Quadro Europeu Comum de Referência para Línguas (CEFR)." },
  { icon: FileCheck, title: "Verificável", text: "Cada certificado possui código de autenticidade para verificação online." },
  { icon: Download, title: "Digital", text: "Disponível para download em PDF de alta qualidade a qualquer momento." },
]

export default function Certificados() {
  const section1 = useScrollReveal()
  const section2 = useScrollReveal()

  return (
    <>
      <PageHero
        title="Certificados"
        subtitle="Comprove sua evolução com certificados reconhecidos em cada etapa do aprendizado."
      />

      <section className="py-20 bg-white">
        <div
          ref={section1.ref}
          className={`max-w-5xl mx-auto px-5 transition-all duration-700 ${section1.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
        >
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
            {beneficios.map((item) => (
              <div key={item.title} className="text-center p-6">
                <div
                  className="w-14 h-14 rounded-xl flex items-center justify-center mx-auto mb-4"
                  style={{ backgroundColor: "#0E8EA015" }}
                >
                  <item.icon size={26} style={{ color: "#0E8EA0" }} />
                </div>
                <h3 className="text-base font-bold mb-2 text-gray-900">{item.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20" style={{ backgroundColor: "#F8F9FA" }}>
        <div
          ref={section2.ref}
          className={`max-w-4xl mx-auto px-5 transition-all duration-700 ${section2.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
        >
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-12" style={{ color: "#0E8EA0" }}>
            Certificados por nível
          </h2>
          <div className="space-y-4">
            {certificados.map((item) => (
              <div
                key={item.level}
                className="bg-white rounded-xl p-5 flex items-center justify-between border border-gray-100 hover:shadow-md transition-all duration-300"
              >
                <div className="flex items-center gap-4">
                  <div
                    className="w-12 h-12 rounded-xl flex items-center justify-center text-white font-black text-lg"
                    style={{ backgroundColor: item.color }}
                  >
                    {item.level}
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900">{item.name}</h3>
                    <p className="text-sm text-gray-500">Carga horária: {item.hours}</p>
                  </div>
                </div>
                <CheckCircle size={22} style={{ color: item.color }} />
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
